import React, { PropsWithChildren } from 'react';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';

import { theme } from './theme';
import { CssBaseline } from '@mui/material';

type Props = PropsWithChildren<{
  //
}>;

export const ThemeProvider = ({ children }: Props) => (
  <MUIThemeProvider theme={theme}>
    <CssBaseline />
    {children}
  </MUIThemeProvider>
);
